import { Box, Button, Container, makeStyles, Chip } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import Page from 'src/components/Page';
import { useDispatch, useSelector } from 'react-redux';
import {
  getRoutes,
  getRouteCategory
} from 'src/store/actions/RouteManagerActions';
import CreateRoute from './CreateRoute';
import UpdateRoute from './UpdateRoute';
import UpdateRouteStatus from './UpdateRouteStatus';
import CustomDataTable from '../../components/Table/CustomDataTable';
import { getRouteCategoryAction } from 'src/store/actions/RouteCategoryActions';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  datatable: {
    marginTop: theme.spacing(2)
  },
  box: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  table: {
    minWidth: 750
    // minHeight: 500
  },
  searchBar: {
    // width: '50%',
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(3)
  }
}));

const RouteManager = () => {
  const classes = useStyles();
  const profile = JSON.parse(sessionStorage.getItem('profile'));
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [openUpdate, setOpenUpdate] = useState(false);
  const [openUpdateStatus, setOpenUpdateStatus] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);
  const [routeDataList, setRouteDataList] = useState([]);
  const dispatch = useDispatch();

  const routeData = useSelector((state) => state.Route.routeData);

  const tableConfig = [
    {
      title: 'SN',
      value: 'sn',
      align: 'center',
      render: (row, i) => <> {i + 1} </>
    },
    {
      title: 'Name',
      value: 'name',
      align: 'center'
    },
    {
      title: 'Route',
      value: 'route',
      align: 'center'
    },
    {
      title: 'Cost',
      value: 'datafull',
      align: 'center'
    },
    // {
    //   title: 'Incomplete Fetch Cost',
    //   value: 'dataless',
    //   align: 'center'
    // },
    // {
    //   title: 'Failed Fetch Cost',
    //   value: 'failed',
    //   align: 'center'
    // },
    {
      title: 'Status',
      value: 'status',
      align: 'center',
      render: (item) => {
        if (item.status == 0) {
          return (
            <Chip
              variant="outlined"
              color="primary"
              size="small"
              label="Deactivated"
            />
          );
        }
        return (
          <Chip
            style={{ background: 'green', color: 'white' }}
            size="small"
            label="Active"
          />
        );
      }
    },
    {
      title: 'Category',
      value: 'category',
      align: 'center',
      render: (row) => row?.route_category?.name
    },
    profile?.super == 1 && {
      title: 'Actions',
      value: '',
      align: 'center',
      render: (item) => (
        <Box style={{ display: 'flex', justifyContent: 'center' }}>
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={() => handleOpenUpdateModal(item)}
          >
            Update Route
          </Button>
          &nbsp;
          <Button
            onClick={() => handleOpenUpdateStatusModal(item)}
            variant="contained"
            color="primary"
            size="small"
          >
            Update Status
          </Button>
        </Box>
      )
    }
  ];

  useEffect(() => {
    async function callGetRoutes() {
      setLoading(true);
      const response = await dispatch(getRoutes({}, profile));
      if (response) {
        setLoading(false);
      }
    }
    callGetRoutes();
  }, []);

  useEffect(() => {
    setRouteDataList(routeData);
  }, [routeData]);

  const handleOpenCreateModal = () => {
    setOpen(true);
  };

  const handleCloseCreateModal = () => {
    setOpen(false);
  };

  const handleOpenUpdateModal = (item) => {
    setOpenUpdate(true);
    setCurrentItem(item);
  };

  const handleOpenUpdateStatusModal = (item) => {
    setOpenUpdateStatus(true);
    setCurrentItem(item);
  };

  return (
    <>
      <CreateRoute open={open} handleClose={handleCloseCreateModal} />
      <UpdateRoute
        open={openUpdate}
        handleClose={() => setOpenUpdate(false)}
        item={currentItem}
        // handle
      />
      <UpdateRouteStatus
        open={openUpdateStatus}
        handleClose={() => setOpenUpdateStatus(false)}
        item={currentItem}
      />
      <Page className={classes.root} title="RouteManager">
        <Container maxWidth="lg">
          {profile?.super == 1 && (
            <Box className={classes.box}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleOpenCreateModal}
              >
                Create Route
              </Button>
            </Box>
          )}

          <Box>
            <CustomDataTable
              className={classes}
              tableConfig={tableConfig}
              tableData={routeDataList}
              loading={loading}
              filterField="name"
            />
          </Box>
        </Container>
      </Page>
    </>
  );
};

export default RouteManager;
